import {FC} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {CouponPage} from "./Pages/Public/CouponPage";

type AppRoutesUserProps = {}

export const AppRoutesUser: FC<AppRoutesUserProps> = (props) => {
  return (
    <Switch>
      <Route path="/users/coupons/:id" component={CouponPage}/>
      {/* マイページ・編集は新デザインの /me, /me/edit に移行 */}
      <Route path="/users/profile/edit"><Redirect to="/me/edit"/></Route>
      <Route exact={true} path="/users" ><Redirect to="/me"/></Route>
      <Route path="/users/profile"><Redirect to="/me"/></Route>
    </Switch>
  )
};
